import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_my_installments = createAsyncThunk(
    'installment/get_my_installments',
    async ({ page = 1, parPage = 10, status = 'all' } = {}, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/installment/my-installments', {
                params: { page, parPage, status }
            })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const get_my_installment = createAsyncThunk(
    'installment/get_my_installment',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/installment/my-installments/${id}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const confirm_flw_installment = createAsyncThunk(
    'installment/confirm_flw_installment',
    async ({ scheduleId, installmentId, transaction_id }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/installment/confirm-flw/${scheduleId}`, {
                installmentId,
                transaction_id
            })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const installmentReducer = createSlice({
    name: 'installment',
    initialState: {
        installments: [],
        totalInstallments: 0,
        selectedInstallment: null,
        successMessage: '',
        errorMessage: '',
        loader: false
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        },
        clearSelectedInstallment: (state) => {
            state.selectedInstallment = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_my_installments.fulfilled, (state, { payload }) => {
                state.installments = payload.installments
                state.totalInstallments = payload.total
            })
            .addCase(get_my_installment.fulfilled, (state, { payload }) => {
                state.selectedInstallment = payload.installment
            })
            .addCase(confirm_flw_installment.pending, (state) => {
                state.loader = true
            })
            .addCase(confirm_flw_installment.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
            })
            .addCase(confirm_flw_installment.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Payment failed'
            })
    }
})

export const { messageClear, clearSelectedInstallment } = installmentReducer.actions
export default installmentReducer.reducer
